export function truncate(str, maxCharacters) {
  if (typeof str !== "string") {
    return ""
  }

  if (str.length <= maxCharacters) {
    return str
  }

  // Trim whitespace, remove trailing punctuation, and add ellipsis
  return (
    str
      .slice(0, maxCharacters)
      .trim()
      .replace(/[!.,;:?'"-]+$/, "") + "..."
  )
}

export const truncateTitle = str => truncate(str, 50)
